import tokens from "../../design-tokens.json"

/**
 * The `vm-*` colors (tailwind.theme.js) for inline styles, such as SVG fills
 * and strokes, so illustrations follow the light/dark palette like the rest
 * of the page. NOTE: Inline styles, not SVG attributes: those don't take
 * `var()`.
 */
export function vmColor(name: string, alpha = 1) {
  return `rgb(var(--vm-${name}) / ${alpha})`
}

/**
 * The app's light palette as hex, for what can't follow the scheme or read
 * CSS variables (an SVG attribute, a QR code that is dark on light in both).
 */
export const lightColors = tokens.color.light

/** A soft fill of `color` on a card (like the app's tints). */
export function tintOf(color: string) {
  return `color-mix(in srgb, ${color} 16%, ${vmColor("surface")})`
}

/** `color` as legible text on its tint: darker on light, lighter on dark. */
export function inkOf(color: string) {
  return `color-mix(in srgb, ${color} 55%, ${vmColor("ink")})`
}
